import apiSlice from "./ApiSlice";

export const TestQuestionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL TestQuestion WITH PAGINATION
    getAllTestQuestionWithPagination: builder.query({
      providesTags: ["test-question"],
      query: (body) => {
        return {
          url: "/test-question",
          method: "POST",
          body,
        };
      },
    }),
    // Add
    addTestQuestion: builder.mutation({
      invalidatesTags: ["test-question"],
      query: (body) => {
        return {
          url: "/test-question/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteTestQuestion: builder.mutation({
      invalidatesTags: ["test-question"],
      query: ({ id }) => {
        return {
          url: `/test-question/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET TestQuestion BY ID
    getTestQuestionById: builder.query({
      providesTags: ["test-question"],
      query: ({ id }) => {
        return {
          url: `/test-question/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editTestQuestion: builder.mutation({
      invalidatesTags: ["test-question"],
      query: ({ body, id }) => {
        return {
          url: `/test-question/${id}`,
          method: "PUT",
          body,
        };
      },
    }),


  }),
});

export const {
  useGetAllTestQuestionWithPaginationQuery,
  useAddTestQuestionMutation,
  useDeleteTestQuestionMutation,
  useEditTestQuestionMutation,
  useGetTestQuestionByIdQuery,
} = TestQuestionApi;
